module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/CarteBancaire-5c3a50dc168189f4c60c8f8618ffd24a.svg";